
export type FacilityType = {
    id:string,
    name:string,
    disabled:boolean
}

export type DefaultFacilityTypesType = {
    other: FacilityType,
    onePersonOffice: FacilityType,
    multiPersonOffice: FacilityType,
    reception: FacilityType,
    kitchen: FacilityType,
    canteen: FacilityType,
    meetingRoom: FacilityType,
    boilerRoom: FacilityType,
    storageFacility: FacilityType,
    serverRoom: FacilityType,
    production: FacilityType,
    stairs: FacilityType,
    hallway: FacilityType,
    elevator: FacilityType,
    bathroom: FacilityType,
    restroom: FacilityType,
    cloakroom: FacilityType,
    gym: FacilityType,
    kitchenette: FacilityType,
    cleaningRoom: FacilityType,
    storageRoom: FacilityType,
    relaxationRoom: FacilityType,
    therapyRoom: FacilityType,
    entertainmentRoom: FacilityType,
    heatExchangerRoom: FacilityType
};

export function allDefaultFacilityTypes()
{
    return Object.values(defaultFacilityTypes);
}

export const defaultFacilityTypes:DefaultFacilityTypesType = {
    other: { id:'other', name:'Andet', disabled:false }, // triggers custom inspection point
    
    // Workspace facilities
    onePersonOffice: { id:'onePersonOffice', name:'Kontor - 1 person', disabled:false },
    multiPersonOffice: { id:'multiPersonOffice', name:'Kontor - flere personer', disabled:false },
    reception: { id:'reception', name:'Reception', disabled:false },
    kitchen: { id:'kitchen', name:'Køkken', disabled:false }, // a workspace used by employees opposed to kitchenette
    canteen: { id:'canteen', name:'Kantine', disabled:false },
    meetingRoom: { id:'meetingRoom', name:'Mødelokale', disabled:false },
    boilerRoom: { id:'boilerRoom', name:'Kedelrum', disabled:false }, // counts as workspace
    storageFacility: { id:'storageFacility', name:'Lager', disabled:false }, // a workspace, opposed to storage room
    serverRoom: { id:'serverRoom', name:'Serverrum', disabled:false }, // a workspace
    production: { id:'production', name:'Produktion', disabled:false },

    stairs: { id:'stairs', name:'Trappe', disabled:false },
    hallway: { id:'hallway', name:'Gangareal', disabled:false },
    elevator: { id:'elevator', name:'Elevator', disabled:false },
    bathroom: { id:'bathroom', name:'Badeværelse', disabled:false },
    restroom: { id:'restroom', name:'Toilet', disabled:false },

    cloakroom: { id:'cloakroom', name:'Garderobe', disabled:false },
    gym: { id:'gym', name:'Fitnessrum', disabled:false },
    kitchenette: { id:'kitchenette', name:'Tekøkken', disabled:false }, // used by staff
    cleaningRoom: { id:'cleaningRoom', name:'Rengøringsrum', disabled:false },
    storageRoom: { id:'storageRoom', name:'Opbevaringsrum', disabled:false },
    relaxationRoom: { id:'relaxationRoom', name:'Afslapningsrum', disabled:false },
    therapyRoom: { id:'therapyRoom', name:'Behandlingsrum', disabled:false },
    entertainmentRoom: { id:'entertainmentRoom', name:'Underholdningsrum', disabled:false },
    heatExchangerRoom: { id:'heatExchangerRoom', name:'Varmevekslerum', disabled:false }
}